export enum URGENCY {
  NORMAL_ID = 'normal',
  TAX_ID = 'taxYearSensitive',
  URGENT_ID = 'urgent',
}
